"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processAdjustment = exports.getSearchResultsForSimpleAdjustment = exports.adjustmentAudit = exports.getSearchResultsForAdjustmentForAudit = exports.printLOI = exports.generateLOI = exports.getResultsForLOI = exports.cancelRefund = exports.getSearchResultsForRefund = exports.cancelReceipt = exports.getSearchResultsForReceipt = exports.updateSuspenseAccount = exports.cancelSuspenseAccount = exports.getSearchResultsForSuspenseAccount = exports.updateMiscPayment = exports.cancelMiscPayment = exports.getSearchResultsForMiscPayment = exports.reviveCancelledDemand = exports.cancelDemand = exports.getSearchResultsForDemand = exports.cancelAdjustment = exports.getSearchResultsForAdjustment = exports.suspenseTransfer = exports.getSearchResultsForSuspenseTransfer = exports.getSearchResultsForSafMaster = exports.getSearchResultsForSafFormat = exports.getSearchResultsForSafList = exports.getSearchResultsForTempAssessee = exports.printMutationCertificate = exports.downloadMutationCertificate = exports.getDomainLink = exports.getSearchBillResult = exports.getBoundaryData = exports.generatePdfFromDiv = exports.setApplicationNumberBox = exports.furnishNocResponse = exports.prepareDocumentsUploadRedux = exports.prepareDocumentsUploadData = exports.createUpdatePTApplication = exports.getSearchResults = exports.findItemInArrayOfObject = exports.getLocaleLabelsforTL = exports.getOrderedByData = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = require("egov-ui-framework/ui-config/screens/specs/utils");

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _commons = require("egov-ui-kit/utils/commons");

var _api = require("./api");

var _api2 = require("egov-ui-kit/utils/api");

var _commons2 = require("egov-ui-framework/ui-utils/commons");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _html2canvas = require("html2canvas");

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _jsonpath = require("jsonpath");

var _jsonpath2 = _interopRequireDefault(_jsonpath);

var _jspdf = require("jspdf");

var _jspdf2 = _interopRequireDefault(_jspdf);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _common = require("config/common.js");

var _common2 = _interopRequireDefault(_common);

var _utils2 = require("../ui-config/screens/specs/utils");

var _actions2 = require("egov-ui-kit/redux/common/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleDeletedCards = function handleDeletedCards(jsonObject, jsonPath, key) {
  var originalArray = (0, _get2.default)(jsonObject, jsonPath, []);
  var modifiedArray = originalArray.filter(function (element) {
    return element.hasOwnProperty(key) || !element.hasOwnProperty("isDeleted");
  });
  modifiedArray = modifiedArray.map(function (element) {
    if (element.hasOwnProperty("isDeleted")) {
      element["isActive"] = false;
    }
    return element;
  });
  (0, _set2.default)(jsonObject, jsonPath, modifiedArray);
};

// call api for ordered by list
var getOrderedByData = exports.getOrderedByData = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(action, state, dispatch) {
    var mdmsBody, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            mdmsBody = {
              MdmsCriteria: {
                tenantId: _common2.default.tenantId,
                moduleDetails: [{
                  moduleName: "PropertyTax",
                  masterDetails: [{
                    name: "Ordered By",
                    officeCode: localStorage.getItem("officeId") || "",
                    filter: "",
                    moduleCode: "ASMT"
                  }]
                }]
              }
            };
            _context.prev = 1;
            response = null;
            _context.next = 5;
            return (0, _api2.httpRequestForPT)("/property-services/common/_searchPropertyDetails", "_search", [], mdmsBody);

          case 5:
            response = _context.sent;

            if (!(response.tokenStatus === "invalid")) {
              _context.next = 11;
              break;
            }

            (0, _commons.showToast)("Invalid Access Token. Please login again", "error");
            return _context.abrupt("return", []);

          case 11:
            if (response.tokenStatus === "valid" && (response.status === 200 || response.status === 201)) dispatch((0, _actions.prepareFinalObject)("applyScreenMdmsData", response.data.data));else if (response.data.hasOwnProperty("Errors") && response.data.Errors && response.data.Errors.length > 0 && response.data.Errors[0].message) {
              (0, _commons.showToast)(response.data.Errors[0].message, "error");
            } else (0, _commons.showToast)("Something went wrong!", "error");

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);

            (0, _commons.showToast)(_context.t0.message, "error");

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 14]]);
  }));

  return function getOrderedByData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getLocaleLabelsforTL = exports.getLocaleLabelsforTL = function getLocaleLabelsforTL(label, labelKey, localizationLabels) {
  if (labelKey) {
    var translatedLabel = (0, _utils2.getTranslatedLabel)(labelKey, localizationLabels);
    if (!translatedLabel || labelKey === translatedLabel) {
      return label;
    } else {
      return translatedLabel;
    }
  } else {
    return label;
  }
};

var findItemInArrayOfObject = exports.findItemInArrayOfObject = function findItemInArrayOfObject(arr, conditionCheckerFn) {
  for (var i = 0; i < arr.length; i++) {
    if (conditionCheckerFn(arr[i])) {
      return arr[i];
    }
  }
};

var getSearchResults = exports.getSearchResults = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/property/_search";
    var response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context2.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context2.sent;

            response && response.Properties && response.Properties.map(function (property) {
              var newOwnerList = [];
              var oldOwnerList = [];
              property.owners.map(function (owner) {
                if (owner.status == "ACTIVE") {
                  newOwnerList.push(owner);
                } else {
                  oldOwnerList.push(owner);
                }
              });
              if (property.status == "INWORKFLOW") {
                oldOwnerList.push.apply(oldOwnerList, newOwnerList);
                property.owners = oldOwnerList;
              } else {
                newOwnerList.push.apply(newOwnerList, oldOwnerList);
                property.owners = newOwnerList;
              }
            });
            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context2.abrupt("return", response);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context2.t0.message, labelKey: _context2.t0.message }, "error"));
            throw _context2.t0;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 10]]);
  }));

  return function getSearchResults(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var createUpdatePTApplication = exports.createUpdatePTApplication = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(state, dispatch, status) {
    var nocId, method, payload, tenantId, reduxDocuments, buildings, ownerDocuments, otherDocuments, owners, response, fireNocData;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            nocId = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.Properties[0].id");
            method = nocId ? "UPDATE" : "CREATE";
            _context3.prev = 2;
            payload = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "FireNOCs", []);
            tenantId = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "FireNOCs[0].fireNOCDetails.propertyDetails.address.city", (0, _localStorageUtils.getTenantId)());

            (0, _set2.default)(payload[0], "tenantId", tenantId);
            (0, _set2.default)(payload[0], "fireNOCDetails.action", status);

            // Get uploaded documents from redux
            reduxDocuments = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.documentsUploadRedux", {});


            handleDeletedCards(payload[0], "fireNOCDetails.buildings", "id");
            handleDeletedCards(payload[0], "fireNOCDetails.applicantDetails.owners", "id");

            buildings = (0, _get2.default)(payload, "[0].fireNOCDetails.buildings", []);

            buildings.forEach(function (building, index) {
              // GET UOMS FOR THE SELECTED BUILDING TYPE
              var requiredUoms = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.applyScreenMdmsData.firenoc.BuildingType", []).filter(function (buildingType) {
                return buildingType.code === building.usageType;
              });
              requiredUoms = (0, _get2.default)(requiredUoms, "[0].uom", []);
              // GET UNIQUE UOMS LIST INCLUDING THE DEFAULT
              var allUoms = [].concat((0, _toConsumableArray3.default)(new Set([].concat((0, _toConsumableArray3.default)(requiredUoms), ["NO_OF_FLOORS", "NO_OF_BASEMENTS", "PLOT_SIZE", "BUILTUP_AREA", "HEIGHT_OF_BUILDING"]))));
              var finalUoms = [];
              allUoms.forEach(function (uom) {
                var value = (0, _get2.default)(building.uomsMap, uom);
                value && finalUoms.push({
                  code: uom,
                  value: parseInt(value),
                  isActiveUom: requiredUoms.includes(uom) ? true : false,
                  active: true
                });
              });

              // Quick fix to repair old uoms
              var oldUoms = (0, _get2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms", []);
              oldUoms.forEach(function (oldUom, oldUomIndex) {
                (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms[" + oldUomIndex + "].isActiveUom", false);
                (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms[" + oldUomIndex + "].active", false);
              });
              // End Quick Fix

              (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms", [].concat(finalUoms, (0, _toConsumableArray3.default)(oldUoms)));

              // Set building documents
              var uploadedDocs = [];
              _jsonpath2.default.query(reduxDocuments, "$.*").forEach(function (doc) {
                if (doc.documents && doc.documents.length > 0) {
                  if (doc.documentSubCode && doc.documentSubCode.startsWith("BUILDING.BUILDING_PLAN")) {
                    if (doc.documentCode === building.name) {
                      uploadedDocs = [].concat((0, _toConsumableArray3.default)(uploadedDocs), [{
                        tenantId: tenantId,
                        documentType: doc.documentSubCode,
                        fileStoreId: doc.documents[0].fileStoreId
                      }]);
                    }
                  }
                }
              });
              (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].applicationDocuments", uploadedDocs);
            });

            // Set owners & other documents
            ownerDocuments = [];
            otherDocuments = [];

            _jsonpath2.default.query(reduxDocuments, "$.*").forEach(function (doc) {
              if (doc.documents && doc.documents.length > 0) {
                if (doc.documentType === "OWNER") {
                  ownerDocuments = [].concat((0, _toConsumableArray3.default)(ownerDocuments), [{
                    tenantId: tenantId,
                    documentType: doc.documentSubCode ? doc.documentSubCode : doc.documentCode,
                    fileStoreId: doc.documents[0].fileStoreId
                  }]);
                } else if (!doc.documentSubCode) {
                  // SKIP BUILDING PLAN DOCS
                  otherDocuments = [].concat((0, _toConsumableArray3.default)(otherDocuments), [{
                    tenantId: tenantId,
                    documentType: doc.documentCode,
                    fileStoreId: doc.documents[0].fileStoreId
                  }]);
                }
              }
            });

            (0, _set2.default)(payload[0], "fireNOCDetails.applicantDetails.additionalDetail.documents", ownerDocuments);
            (0, _set2.default)(payload[0], "fireNOCDetails.additionalDetail.documents", otherDocuments);

            // Set Channel and Financial Year
            process.env.REACT_APP_NAME === "Citizen" ? (0, _set2.default)(payload[0], "fireNOCDetails.channel", "CITIZEN") : (0, _set2.default)(payload[0], "fireNOCDetails.channel", "COUNTER");
            (0, _set2.default)(payload[0], "fireNOCDetails.financialYear", "2019-20");

            // Set Dates to Epoch
            owners = (0, _get2.default)(payload[0], "fireNOCDetails.applicantDetails.owners", []);

            owners.forEach(function (owner, index) {
              (0, _set2.default)(payload[0], "fireNOCDetails.applicantDetails.owners[" + index + "].dob", (0, _utils.convertDateToEpoch)((0, _get2.default)(owner, "dob")));
            });

            response = void 0;

            if (!(method === "CREATE")) {
              _context3.next = 31;
              break;
            }

            _context3.next = 25;
            return httpRequest("post", "/firenoc-services/v1/_create", "", [], { FireNOCs: payload });

          case 25:
            response = _context3.sent;

            response = furnishNocResponse(response);
            dispatch((0, _actions.prepareFinalObject)("FireNOCs", response.FireNOCs));
            setApplicationNumberBox(state, dispatch);
            _context3.next = 37;
            break;

          case 31:
            if (!(method === "UPDATE")) {
              _context3.next = 37;
              break;
            }

            _context3.next = 34;
            return httpRequest("post", "/firenoc-services/v1/_update", "", [], { FireNOCs: payload });

          case 34:
            response = _context3.sent;

            response = furnishNocResponse(response);
            dispatch((0, _actions.prepareFinalObject)("FireNOCs", response.FireNOCs));

          case 37:
            return _context3.abrupt("return", { status: "success", message: response });

          case 40:
            _context3.prev = 40;
            _context3.t0 = _context3["catch"](2);

            dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context3.t0.message }, "error"));

            // Revert the changed pfo in case of request failure
            fireNocData = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.FireNOCs", []);

            fireNocData = furnishNocResponse({ FireNOCs: fireNocData });
            dispatch((0, _actions.prepareFinalObject)("FireNOCs", fireNocData.FireNOCs));

            return _context3.abrupt("return", { status: "failure", message: _context3.t0 });

          case 47:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[2, 40]]);
  }));

  return function createUpdatePTApplication(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

var prepareDocumentsUploadData = exports.prepareDocumentsUploadData = function prepareDocumentsUploadData(state, dispatch) {
  var documents = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.applyScreenMdmsData.PropertyTax.MutationDocuments", []);
  documents = documents.filter(function (item) {
    return item.active;
  });
  var documentsContract = [];
  var tempDoc = {};
  documents.forEach(function (doc) {
    var card = {};
    card["code"] = doc.documentType;
    card["title"] = doc.documentType;
    card["cards"] = [];
    tempDoc[doc.documentType] = card;
  });

  documents.forEach(function (doc) {
    // Handle the case for multiple muildings

    var card = {};
    card["name"] = doc.code;
    card["code"] = doc.code;
    card["required"] = doc.required ? true : false;
    if (doc.additionalDetails && doc.additionalDetails.filterCondition) {
      card["filterCondition"] = doc.additionalDetails.filterCondition;
    }
    if (doc.additionalDetails && doc.additionalDetails.dropdownFilter) {
      card["dropdownFilter"] = doc.additionalDetails.dropdownFilter;
    }

    // if(doc.code=='OWNER_REGISTRATIONPROOF'){
    //   card["filterCondition"]={"filterValue":["NONE"],"jsonPath":"Property.ownersTemp","onArray":true,"arrayAttribute":"ownerType"};
    // }
    if (doc.hasDropdown && doc.dropdownData) {
      var dropdown = {};
      dropdown.label = "PT_MUTATION_SELECT_DOC_LABEL";
      dropdown.required = true;
      dropdown.menu = doc.dropdownData.filter(function (item) {
        return item.active;
      });
      dropdown.menu = dropdown.menu.map(function (item) {
        var menuItem = {
          code: item.code,
          label: (0, _commons2.getTransformedLocale)(item.code)
        };
        if (item.parentValue) {
          menuItem["parentValue"] = item.parentValue;
        }
        return (0, _extends3.default)({}, menuItem);
      });
      card["dropdown"] = dropdown;
    }
    tempDoc[doc.documentType].cards.push(card);
  });

  Object.keys(tempDoc).forEach(function (key) {
    documentsContract.push(tempDoc[key]);
  });

  dispatch((0, _actions.prepareFinalObject)("documentsContract", documentsContract));
};

var prepareDocumentsUploadRedux = exports.prepareDocumentsUploadRedux = function prepareDocumentsUploadRedux(state, dispatch) {
  var _props = undefined.props,
      documentsList = _props.documentsList,
      _props$documentsUploa = _props.documentsUploadRedux,
      documentsUploadRedux = _props$documentsUploa === undefined ? {} : _props$documentsUploa,
      prepareFinalObject = _props.prepareFinalObject;

  var index = 0;
  documentsList.forEach(function (docType) {
    docType.cards && docType.cards.forEach(function (card) {
      if (card.subCards) {
        card.subCards.forEach(function (subCard) {
          var oldDocType = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentType");
          var oldDocCode = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentCode");
          var oldDocSubCode = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentSubCode");
          if (oldDocType != docType.code || oldDocCode != card.name || oldDocSubCode != subCard.name) {
            documentsUploadRedux[index] = {
              documentType: docType.code,
              documentCode: card.name,
              documentSubCode: subCard.name
            };
          }
          index++;
        });
      } else {
        var oldDocType = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentType");
        var oldDocCode = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentCode");
        if (oldDocType != docType.code || oldDocCode != card.name) {
          documentsUploadRedux[index] = {
            documentType: docType.code,
            documentCode: card.name,
            isDocumentRequired: card.required,
            isDocumentTypeRequired: card.dropdown ? card.dropdown.required : false
          };
        }
      }
      index++;
    });
  });
  prepareFinalObject("documentsUploadRedux", documentsUploadRedux);
};

var furnishNocResponse = exports.furnishNocResponse = function furnishNocResponse(response) {
  // Handle applicant ownership dependent dropdowns
  var ownershipType = (0, _get2.default)(response, "FireNOCs[0].fireNOCDetails.applicantDetails.ownerShipType");
  (0, _set2.default)(response, "FireNOCs[0].fireNOCDetails.applicantDetails.ownerShipMajorType", ownershipType == undefined ? "SINGLE" : ownershipType.split(".")[0]);

  // Prepare UOMS and Usage Type Dropdowns in required format
  var buildings = (0, _get2.default)(response, "FireNOCs[0].fireNOCDetails.buildings", []);
  buildings.forEach(function (building, index) {
    var uoms = (0, _get2.default)(building, "uoms", []);
    var uomMap = {};
    uoms.forEach(function (uom) {
      uomMap[uom.code] = "" + uom.value;
    });
    (0, _set2.default)(response, "FireNOCs[0].fireNOCDetails.buildings[" + index + "].uomsMap", uomMap);

    var usageType = (0, _get2.default)(building, "usageType");
    (0, _set2.default)(response, "FireNOCs[0].fireNOCDetails.buildings[" + index + "].usageTypeMajor", usageType == undefined ? "" : usageType.split(".")[0]);
  });

  return response;
};

var setApplicationNumberBox = exports.setApplicationNumberBox = function setApplicationNumberBox(state, dispatch, applicationNo) {
  if (!applicationNo) {
    applicationNo = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.FireNOCs[0].fireNOCDetails.applicationNumber", null);
  }

  if (applicationNo) {
    dispatch((0, _actions.handleScreenConfigurationFieldChange)("apply", "components.div.children.headerDiv.children.header.children.applicationNumber", "visible", true));
    dispatch((0, _actions.handleScreenConfigurationFieldChange)("apply", "components.div.children.headerDiv.children.header.children.applicationNumber", "props.number", applicationNo));
  }
};
var generatePdfFromDiv = exports.generatePdfFromDiv = function generatePdfFromDiv(action, applicationNumber, divID) {
  var divName = divID ? divID : "#material-ui-cardContent";
  var target = document.querySelector(divName);
  (0, _html2canvas2.default)(target, {
    // imageTimeout: 1500000000,
    onclone: function onclone(clonedDoc) {
      if (clonedDoc.getElementById("pdf-header")) {
        clonedDoc.getElementById("pdf-header").style.display = "block";
      }

      // if(clonedDoc.getElementById("property-assess-form")){
      //   clonedDoc.getElementById("property-assess-form").style.display = "none";
      // }
      // if(clonedDoc.getElementById("pt-header-button-container")){
      //   clonedDoc.getElementById("pt-header-button-container").style.display = "none";
      // }
      // if(clonedDoc.getElementById("pt-flex-child-button")){
      //   clonedDoc.getElementById("pt-flex-child-button").style.display = "none";
      // }
    }
  }).then(function (canvas) {
    var data = canvas.toDataURL("image/jpeg", 1);
    var imgWidth = 200;
    var pageHeight = 290;
    var imgHeight = canvas.height * imgWidth / canvas.width;
    var heightLeft = imgHeight;
    var doc = new _jspdf2.default("p", "mm");
    var position = 0;

    doc.addImage(data, "PNG", 5, 5 + position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      doc.addPage();
      doc.addImage(data, "PNG", 5, 10 + position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    if (action === "download") {
      doc.save("preview-" + applicationNumber + ".pdf");
    } else if (action === "print") {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  });
};

var getBoundaryData = exports.getBoundaryData = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(action, state, dispatch, queryObject, code, componentPath) {
    var payload, tenantId, mohallaData, data, messageObject;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return httpRequest("post", "/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=REVENUE&boundaryType=Locality", "_search", queryObject, {});

          case 3:
            payload = _context4.sent;
            tenantId = process.env.REACT_APP_NAME === "Employee" ? (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Property.address.city") : (0, _commons2.getQueryArg)(window.location.href, "tenantId");
            mohallaData = payload && payload.TenantBoundary[0] && payload.TenantBoundary[0].boundary && payload.TenantBoundary[0].boundary.reduce(function (result, item) {
              result.push((0, _extends3.default)({}, item, {
                name: tenantId.toUpperCase().replace(/[.]/g, "_") + "_REVENUE_" + item.code.toUpperCase().replace(/[._:-\s\/]/g, "_")
              }));
              return result;
            }, []);


            dispatch((0, _actions.prepareFinalObject)("applyScreenMdmsData.tenant.localities",
            // payload.TenantBoundary && payload.TenantBoundary[0].boundary,
            mohallaData));

            dispatch((0, _actions.handleScreenConfigurationFieldChange)("register-property", "components.div.children.formwizardFirstStep.children.propertyLocationDetails.children.cardContent.children.propertyLocationDetailsContainer.children.localityOrMohalla", "props.suggestions", mohallaData));
            if (code) {
              data = payload.TenantBoundary[0].boundary;
              messageObject = data && data.find(function (item) {
                return item.code == code;
              });

              if (messageObject) dispatch((0, _actions.prepareFinalObject)("Property.address.locality.name", messageObject.name));
            }
            _context4.next = 14;
            break;

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);

            console.log(_context4.t0);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[0, 11]]);
  }));

  return function getBoundaryData(_x10, _x11, _x12, _x13, _x14, _x15) {
    return _ref4.apply(this, arguments);
  };
}();

var getSearchBillResult = exports.getSearchBillResult = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(queryObject, dispatch) {
    var response;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return httpRequest("post", "/billing-service/bill/v2/_fetchbill", "", queryObject);

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);

            dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context5.t0.message, labelKey: _context5.t0.message }, "error"));
            console.log(_context5.t0, "fetxh");

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[0, 7]]);
  }));

  return function getSearchBillResult(_x16, _x17) {
    return _ref5.apply(this, arguments);
  };
}();

var getDomainLink = exports.getDomainLink = function getDomainLink() {
  var link = "";
  if (process.env.NODE_ENV !== "development") {
    link += "/" + process.env.REACT_APP_NAME.toLowerCase();
  }
  return link;
};

var downloadMutationCertificate = exports.downloadMutationCertificate = function downloadMutationCertificate(queryObj, fileName) {
  searchAndDownloadPdf("/egov-pdf/download/PT/ptmutationcertificate", queryObj, fileName);
};

var printMutationCertificate = exports.printMutationCertificate = function printMutationCertificate(queryObj) {
  searchAndPrintPdf("/egov-pdf/download/PT/ptmutationcertificate", queryObj);
};

var getSearchResultsForTempAssessee = exports.getSearchResultsForTempAssessee = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/property/_search";
    var response;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context6.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context6.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context6.abrupt("return", response);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context6.t0.message, labelKey: _context6.t0.message }, "error"));
            throw _context6.t0;

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForTempAssessee(_x18, _x19) {
    return _ref6.apply(this, arguments);
  };
}();
var getSearchResultsForSafList = exports.getSearchResultsForSafList = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(safNo, assesseeNo, queryObject, requestBody) {
    var searchURL = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "/property-services/assessment/_saflistsearch";
    var SelfAssessmentForm, response;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());

            SelfAssessmentForm = {
              safNo: safNo,
              assesseeNo: assesseeNo
            };
            _context7.next = 5;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", [], {
              SelfAssessmentForm: SelfAssessmentForm
            });

          case 5:
            response = _context7.sent;

            console.log("response1234", response);
            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context7.abrupt("return", response);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context7.t0.message, labelKey: _context7.t0.message }, "error"));
            throw _context7.t0;

          case 16:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[0, 11]]);
  }));

  return function getSearchResultsForSafList(_x21, _x22, _x23, _x24) {
    return _ref7.apply(this, arguments);
  };
}();
var getSearchResultsForSafFormat = exports.getSearchResultsForSafFormat = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(safNo, assesseeNo, queryObject, requestBody) {
    var searchURL = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "/property-services/assessment/_fetchUaaSafDetails?fetchType=Details";
    var SelfAssessmentForm, response;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());

            SelfAssessmentForm = {
              safNo: safNo,
              safVersion: "A"
            };
            _context8.next = 5;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", [], {
              requestData: SelfAssessmentForm
            });

          case 5:
            response = _context8.sent;


            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context8.abrupt("return", response.ResponseData);

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context8.t0.message, labelKey: _context8.t0.message }, "error"));
            throw _context8.t0;

          case 15:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[0, 10]]);
  }));

  return function getSearchResultsForSafFormat(_x26, _x27, _x28, _x29) {
    return _ref8.apply(this, arguments);
  };
}();
var getSearchResultsForSafMaster = exports.getSearchResultsForSafMaster = function () {
  var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(safNo, assesseeNo, queryObject, requestBody) {
    var searchURL = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "/property-services/assessment/_fetchUaaSafDetails?fetchType=MASTER";
    var SelfAssessmentForm, response;
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());

            SelfAssessmentForm = {
              safNo: safNo,
              safVersion: "A"
            };
            _context9.next = 5;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", [], {
              requestData: SelfAssessmentForm
            });

          case 5:
            response = _context9.sent;


            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context9.abrupt("return", response.ResponseData);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context9.t0.message, labelKey: _context9.t0.message }, "error"));
            throw _context9.t0;

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[0, 10]]);
  }));

  return function getSearchResultsForSafMaster(_x31, _x32, _x33, _x34) {
    return _ref9.apply(this, arguments);
  };
}();
var getSearchResultsForSuspenseTransfer = exports.getSearchResultsForSuspenseTransfer = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_searchSuspenseTransferDetails";
    var response;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context10.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context10.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context10.abrupt("return", response);

          case 9:
            _context10.prev = 9;
            _context10.t0 = _context10["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context10.t0.message, labelKey: _context10.t0.message }, "error"));
            throw _context10.t0;

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForSuspenseTransfer(_x36, _x37) {
    return _ref10.apply(this, arguments);
  };
}();

var suspenseTransfer = exports.suspenseTransfer = function () {
  var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_saveSuspenseTransfer";
    var response;
    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;

            _store2.default.dispatch((0, _actions2.showSpinner)());
            _context11.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context11.sent;

            _store2.default.dispatch((0, _actions2.hideSpinner)());
            return _context11.abrupt("return", response);

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](0);

            _store2.default.dispatch((0, _actions2.hideSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context11.t0.message, labelKey: _context11.t0.message }, "error"));
            throw _context11.t0;

          case 14:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, undefined, [[0, 9]]);
  }));

  return function suspenseTransfer(_x39, _x40) {
    return _ref11.apply(this, arguments);
  };
}();

var getSearchResultsForAdjustment = exports.getSearchResultsForAdjustment = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_searchAdjustment";
    var response;
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context12.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context12.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context12.abrupt("return", response);

          case 9:
            _context12.prev = 9;
            _context12.t0 = _context12["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context12.t0.message, labelKey: _context12.t0.message }, "error"));
            throw _context12.t0;

          case 14:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForAdjustment(_x42, _x43) {
    return _ref12.apply(this, arguments);
  };
}();

var cancelAdjustment = exports.cancelAdjustment = function () {
  var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_cancelAdjustment";
    var response;
    return _regenerator2.default.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context13.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context13.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context13.abrupt("return", response);

          case 9:
            _context13.prev = 9;
            _context13.t0 = _context13["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context13.t0.message, labelKey: _context13.t0.message }, "error"));
            throw _context13.t0;

          case 14:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, undefined, [[0, 9]]);
  }));

  return function cancelAdjustment(_x45, _x46) {
    return _ref13.apply(this, arguments);
  };
}();

var getSearchResultsForDemand = exports.getSearchResultsForDemand = function () {
  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_fetchDemandDetails";
    var response;
    return _regenerator2.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context14.next = 4;
            return (0, _api2.httpRequestForPT)(searchURL, "", queryObject, requestBody);

          case 4:
            response = _context14.sent;


            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context14.abrupt("return", response);

          case 9:
            _context14.prev = 9;
            _context14.t0 = _context14["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context14.t0.message, labelKey: _context14.t0.message }, "error"));
            throw _context14.t0;

          case 13:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForDemand(_x48, _x49) {
    return _ref14.apply(this, arguments);
  };
}();

var cancelDemand = exports.cancelDemand = function () {
  var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_cancelDemand";
    var response;
    return _regenerator2.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context15.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context15.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context15.abrupt("return", response);

          case 9:
            _context15.prev = 9;
            _context15.t0 = _context15["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context15.t0.message, labelKey: _context15.t0.message }, "error"));
            throw _context15.t0;

          case 14:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, undefined, [[0, 9]]);
  }));

  return function cancelDemand(_x51, _x52) {
    return _ref15.apply(this, arguments);
  };
}();

var reviveCancelledDemand = exports.reviveCancelledDemand = function () {
  var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_reviveCancelDemand";
    var response;
    return _regenerator2.default.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context16.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context16.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context16.abrupt("return", response);

          case 9:
            _context16.prev = 9;
            _context16.t0 = _context16["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context16.t0.message, labelKey: _context16.t0.message }, "error"));
            throw _context16.t0;

          case 14:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, undefined, [[0, 9]]);
  }));

  return function reviveCancelledDemand(_x54, _x55) {
    return _ref16.apply(this, arguments);
  };
}();

var getSearchResultsForMiscPayment = exports.getSearchResultsForMiscPayment = function () {
  var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_searchPaymentDetails";
    var response;
    return _regenerator2.default.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context17.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context17.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context17.abrupt("return", response);

          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context17.t0.message, labelKey: _context17.t0.message }, "error"));
            throw _context17.t0;

          case 14:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForMiscPayment(_x57, _x58) {
    return _ref17.apply(this, arguments);
  };
}();

var cancelMiscPayment = exports.cancelMiscPayment = function () {
  var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_cancelReceipt";
    var response;
    return _regenerator2.default.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context18.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context18.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context18.abrupt("return", response);

          case 9:
            _context18.prev = 9;
            _context18.t0 = _context18["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context18.t0.message, labelKey: _context18.t0.message }, "error"));
            throw _context18.t0;

          case 14:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, undefined, [[0, 9]]);
  }));

  return function cancelMiscPayment(_x60, _x61) {
    return _ref18.apply(this, arguments);
  };
}();

var updateMiscPayment = exports.updateMiscPayment = function () {
  var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_updateMiscPaymentDetails";
    var response;
    return _regenerator2.default.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context19.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context19.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context19.abrupt("return", response);

          case 9:
            _context19.prev = 9;
            _context19.t0 = _context19["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context19.t0.message, labelKey: _context19.t0.message }, "error"));
            throw _context19.t0;

          case 14:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, undefined, [[0, 9]]);
  }));

  return function updateMiscPayment(_x63, _x64) {
    return _ref19.apply(this, arguments);
  };
}();

var getSearchResultsForSuspenseAccount = exports.getSearchResultsForSuspenseAccount = function () {
  var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_fetchAsseseeSuspenseList";
    var response;
    return _regenerator2.default.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context20.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context20.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context20.abrupt("return", response);

          case 9:
            _context20.prev = 9;
            _context20.t0 = _context20["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context20.t0.message, labelKey: _context20.t0.message }, "error"));
            throw _context20.t0;

          case 14:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForSuspenseAccount(_x66, _x67) {
    return _ref20.apply(this, arguments);
  };
}();

var cancelSuspenseAccount = exports.cancelSuspenseAccount = function () {
  var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_cancelSuspenseAccount";
    var response;
    return _regenerator2.default.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context21.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context21.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context21.abrupt("return", response);

          case 9:
            _context21.prev = 9;
            _context21.t0 = _context21["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context21.t0.message, labelKey: _context21.t0.message }, "error"));
            throw _context21.t0;

          case 14:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, undefined, [[0, 9]]);
  }));

  return function cancelSuspenseAccount(_x69, _x70) {
    return _ref21.apply(this, arguments);
  };
}();

var updateSuspenseAccount = exports.updateSuspenseAccount = function () {
  var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_cancelSuspenseAccount";
    var response;
    return _regenerator2.default.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context22.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context22.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context22.abrupt("return", response);

          case 9:
            _context22.prev = 9;
            _context22.t0 = _context22["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context22.t0.message, labelKey: _context22.t0.message }, "error"));
            throw _context22.t0;

          case 14:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, undefined, [[0, 9]]);
  }));

  return function updateSuspenseAccount(_x72, _x73) {
    return _ref22.apply(this, arguments);
  };
}();

var getSearchResultsForReceipt = exports.getSearchResultsForReceipt = function () {
  var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_searchPaymentDetails";
    var response;
    return _regenerator2.default.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context23.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context23.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context23.abrupt("return", response);

          case 9:
            _context23.prev = 9;
            _context23.t0 = _context23["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context23.t0.message, labelKey: _context23.t0.message }, "error"));
            throw _context23.t0;

          case 14:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForReceipt(_x75, _x76) {
    return _ref23.apply(this, arguments);
  };
}();

var cancelReceipt = exports.cancelReceipt = function () {
  var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/SearchCancel/_cancelReceipt";
    var response;
    return _regenerator2.default.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context24.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context24.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context24.abrupt("return", response);

          case 9:
            _context24.prev = 9;
            _context24.t0 = _context24["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context24.t0.message, labelKey: _context24.t0.message }, "error"));
            throw _context24.t0;

          case 14:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, undefined, [[0, 9]]);
  }));

  return function cancelReceipt(_x78, _x79) {
    return _ref24.apply(this, arguments);
  };
}();

var getSearchResultsForRefund = exports.getSearchResultsForRefund = function () {
  var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_searchRefundApplication";
    var response;
    return _regenerator2.default.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context25.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context25.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context25.abrupt("return", response);

          case 9:
            _context25.prev = 9;
            _context25.t0 = _context25["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context25.t0.message, labelKey: _context25.t0.message }, "error"));
            throw _context25.t0;

          case 14:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForRefund(_x81, _x82) {
    return _ref25.apply(this, arguments);
  };
}();
var cancelRefund = exports.cancelRefund = function () {
  var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_updateRefundApplication";
    var response;
    return _regenerator2.default.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context26.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context26.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context26.abrupt("return", response);

          case 9:
            _context26.prev = 9;
            _context26.t0 = _context26["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context26.t0.message, labelKey: _context26.t0.message }, "error"));
            throw _context26.t0;

          case 13:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, undefined, [[0, 9]]);
  }));

  return function cancelRefund(_x84, _x85) {
    return _ref26.apply(this, arguments);
  };
}();
var getResultsForLOI = exports.getResultsForLOI = function () {
  var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_processMayorWaiverDetails";
    var response;
    return _regenerator2.default.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context27.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context27.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context27.abrupt("return", response);

          case 9:
            _context27.prev = 9;
            _context27.t0 = _context27["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context27.t0.message, labelKey: _context27.t0.message }, "error"));
            throw _context27.t0;

          case 14:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27, undefined, [[0, 9]]);
  }));

  return function getResultsForLOI(_x87, _x88) {
    return _ref27.apply(this, arguments);
  };
}();
var generateLOI = exports.generateLOI = function () {
  var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_generateLoi";
    var response;
    return _regenerator2.default.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            _context28.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context28.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context28.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context28.abrupt("return", response);

          case 9:
            _context28.prev = 9;
            _context28.t0 = _context28["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context28.t0.message, labelKey: _context28.t0.message }, "error"));
            throw _context28.t0;

          case 13:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, undefined, [[0, 9]]);
  }));

  return function generateLOI(_x90, _x91) {
    return _ref28.apply(this, arguments);
  };
}();
var printLOI = exports.printLOI = function () {
  var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/report/_loiReport?wardNo=" + requestBody.RequestData.wardNo + "&assNo=" + requestBody.RequestData.assNo + "&loiNo=" + requestBody.RequestData.loiNo + "&loiType=012";
    return _regenerator2.default.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.prev = 0;

            //store.dispatch(showSpinner());
            _store2.default.dispatch((0, _actions.toggleSpinner)());
            (0, _commons.reportPrintHandler)(searchURL, [], [], "LOI_Report_Mayor_Waiver");
            _store2.default.dispatch((0, _actions.toggleSpinner)());
            // const response = await httpRequestForPTNew(
            //   "post",
            //   searchURL,
            //   "",
            //   [],
            //   {}
            // );
            // store.dispatch(hideSpinner());
            // if(response)
            // {
            //   //const blob = new Blob([response.data], { type: "application/pdf" });
            //   const blob = new Blob([response], { type: "application/pdf" });
            //   const url = URL.createObjectURL(blob);

            //   const a = document.createElement("a");
            //   a.href = url;
            //   a.download = "LOI_Report_Mayor_Waiver.pdf";
            //   a.click();

            //   URL.revokeObjectURL(url);
            //   // if (successCallback && typeof successCallback === "function") {
            //   //   successCallback();
            //   // }
            // }
            //return response;
            _store2.default.dispatch((0, _actions2.hideSpinner)());
            _context29.next = 12;
            break;

          case 7:
            _context29.prev = 7;
            _context29.t0 = _context29["catch"](0);

            _store2.default.dispatch((0, _actions2.hideSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context29.t0.message, labelKey: _context29.t0.message }, "error"));
            throw _context29.t0;

          case 12:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, undefined, [[0, 7]]);
  }));

  return function printLOI(_x93, _x94) {
    return _ref29.apply(this, arguments);
  };
}();

var getSearchResultsForAdjustmentForAudit = exports.getSearchResultsForAdjustmentForAudit = function () {
  var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_fetchAdjustmentDetailsForAudit";
    var response;
    return _regenerator2.default.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context30.next = 4;
            return (0, _api2.httpRequestForPT)(searchURL, "", queryObject, requestBody);

          case 4:
            response = _context30.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context30.abrupt("return", response);

          case 9:
            _context30.prev = 9;
            _context30.t0 = _context30["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context30.t0.message, labelKey: _context30.t0.message }, "error"));
            throw _context30.t0;

          case 13:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForAdjustmentForAudit(_x96, _x97) {
    return _ref30.apply(this, arguments);
  };
}();
var adjustmentAudit = exports.adjustmentAudit = function () {
  var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_updateAdjustmentAndAudit";
    var response;
    return _regenerator2.default.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context31.next = 4;
            return (0, _api.httpRequestForPTNew)("post", searchURL, "", queryObject, requestBody);

          case 4:
            response = _context31.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context31.abrupt("return", response);

          case 9:
            _context31.prev = 9;
            _context31.t0 = _context31["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context31.t0.message, labelKey: _context31.t0.message }, "error"));
            throw _context31.t0;

          case 14:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31, undefined, [[0, 9]]);
  }));

  return function adjustmentAudit(_x99, _x100) {
    return _ref31.apply(this, arguments);
  };
}();
var getSearchResultsForSimpleAdjustment = exports.getSearchResultsForSimpleAdjustment = function () {
  var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_fetchAdjustmentDetails";
    var response;
    return _regenerator2.default.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context32.next = 4;
            return (0, _api2.httpRequestForPT)(searchURL, "", queryObject, requestBody);

          case 4:
            response = _context32.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context32.abrupt("return", response);

          case 9:
            _context32.prev = 9;
            _context32.t0 = _context32["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context32.t0.message, labelKey: _context32.t0.message }, "error"));
            throw _context32.t0;

          case 13:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32, undefined, [[0, 9]]);
  }));

  return function getSearchResultsForSimpleAdjustment(_x102, _x103) {
    return _ref32.apply(this, arguments);
  };
}();
var processAdjustment = exports.processAdjustment = function () {
  var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(queryObject, requestBody) {
    var searchURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/property-services/DemandCollection/_processAdjustment";
    var response;
    return _regenerator2.default.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context33.next = 4;
            return (0, _api2.httpRequestForPT)(searchURL, "", queryObject, requestBody);

          case 4:
            response = _context33.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context33.abrupt("return", response);

          case 9:
            _context33.prev = 9;
            _context33.t0 = _context33["catch"](0);


            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context33.t0.message, labelKey: _context33.t0.message }, "error"));
            throw _context33.t0;

          case 13:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, undefined, [[0, 9]]);
  }));

  return function processAdjustment(_x105, _x106) {
    return _ref33.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ../lib/egov-pt/ui-utils/commons.js
// module id = 2190
// module chunks = 1137